import { Injectable } from '@angular/core';
import { MenuItem } from '@core/models';
import { map, Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectCartList } from '@store/selectors';
import { StoreService } from '../store/store.service';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  cartList$: Observable<MenuItem[] | null>;

  private updateAllStockCompletedSource = new Subject<void>();
  updateAllStockCompleted$ = this.updateAllStockCompletedSource.asObservable();

  constructor(
    private store: Store<AppState>,
    private storeService: StoreService,
  ) {
    this.cartList$ = this.store.select(selectCartList)
  }

  updateAllStockCompleted(): void {
    this.updateAllStockCompletedSource.next();
  }

  getStoreForStore(): Observable<MenuItem[]> {
    return this.cartList$
      .pipe(
        map((cartList) => cartList?.filter((cart)=> cart.storeSlug === this.storeService.getCurrentSlug()) ?? [])
      );
  }
}
